import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';

import _ from 'lodash';

import { Agent } from '../models';
import { LicensePlan } from '../models/license-plan';

@Pipe({
    name: 'licensePlanFilter',
    standalone: false
})
export class LicensePlanFilterPipe implements PipeTransform {
	private newBusinessFullIds = CONSTANTS.licensePlans.businessFullIds;
	private oldBusinessFullIds = CONSTANTS.licensePlans.oldBusinessFullIds;
	private businessFullIds = this.newBusinessFullIds.concat(this.oldBusinessFullIds);

	// do not show unless already assigned it
	private showParentBusinessLicenses(licensePlan: LicensePlan, agent: Agent, isAdmin: boolean) {
		const licensePlanId = licensePlan.id;
		return (
			this.newBusinessFullIds.includes(licensePlanId) || // return business full
			(isAdmin && this.oldBusinessFullIds.includes(licensePlanId)) || // return special business fulls
			(CONSTANTS.licensePlans.businessLiteIds.includes(licensePlanId) && agent.hasSeparateBusinessLite()) ||
			(this.businessFullIds.includes(licensePlanId) && agent.hasSeparateBusinessNoCharge())
		);
	}

	transform(licensePlans: LicensePlan[], agent: Agent, isAdmin: boolean): any {
		if (!licensePlans) {
			return licensePlans;
		}

		return _.orderBy(
			licensePlans.filter(l => !l.parents?.length && this.showParentBusinessLicenses(l, agent, isAdmin)),
			l => l.name,
			'desc',
		);
	}
}
